import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import {
  white,
  darkBlue,
  green, headerMaxWidth,
} from '@css/constants'

export const RequestCallWrapper = styled('div')(css``)

export type SpeakToProps = {
  headerText?: string
}

export const SpeakTo = styled('div')<SpeakToProps>((props) => css`

  @media(max-width: ${headerMaxWidth}) {
    ${props.headerText ? `display: none;` : ''}
  }
`)

export const PhoneNumberWrapper = styled('div')(css`
  padding-top: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: right;
`)

export const SpeakText = styled('div')(css`
  ${FontNormal(600)}
  ${fontSize(12)};
`)

export const PopupSubtitle = styled('p')(css`
  ${FontNormal(400)}
  ${fontSize(16)};
  margin: 15px 0;
`)

export const PhoneRingingIconWrapper = styled('div')(css`
  margin-right: 6px;
  position: relative;
  top: 3px;

  & > svg {
    height: 24px;
    width: 24px;
  }
`)

export const MobilePhoneIconWrapper = styled('div')(css`
  color: ${green};
`)

export const getQuoteButtonStyles = css`
  margin-left: 15px;
  padding: 14px 43px;
`

export const callButtonStyles = css`
  color: ${darkBlue};
`

export const popupCallButtonStyles = css`
  color: ${white};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 22px;
`

export const popupRequestCallButtonStyles = css`
  margin: 6px auto;

  & > svg {
    position: relative;
    top: 4px;
    margin-left: 6px;
    height: 12px;
  }
`
